import type { CompanyBaseInfo } from "app/pages/sales-intelligence/modules/company-analysis/types/company";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import type { SignalsDescription } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalsDescription";

import AdNetworkSignalEventInfoBox from "./AdNetworkSignalEventInfoBox";
import EcommerceSignalEventInfoBox from "./EcommerceSignalEventInfoBox";
import IntentSignalEventInfoBox from "./IntentSignalEventInfoBox/IntentSignalEventInfoBox";
import NewsSignalEventInfoBox from "./NewsSignalEventInfoBox";
import TechnologySignalEventInfoBox from "./TechnologySignalEventInfoBox";
import TrafficSignalEventInfoBox from "./TrafficSignalEventInfoBox";

type SignalEventInfoProps = {
    signal: SignalEventDto;
    companyInfo?: CompanyBaseInfo;
    signalsDescription: Readonly<SignalsDescription> | null;
    onCompanyLinkClick: (signalEvent: SignalEventDto) => void;
};

const SignalEventInfoBox = ({ signal, companyInfo, signalsDescription, onCompanyLinkClick }: SignalEventInfoProps) => {
    const { type } = signal;

    const companyName = companyInfo?.name || "";

    if (type === SignalType.Intent) {
        return <IntentSignalEventInfoBox signal={signal} />;
    }

    if (type === SignalType.News) {
        return (
            <NewsSignalEventInfoBox
                signal={signal}
                onCompanyLinkClick={onCompanyLinkClick}
                data-automation="signal-event-info-news"
            />
        );
    }
    if (type === SignalType.Technology) {
        return (
            <TechnologySignalEventInfoBox
                signal={signal}
                companyName={companyName}
                data-automation="signal-event-info-technology"
            />
        );
    }
    if (type === SignalType.AdNetwork) {
        return (
            <AdNetworkSignalEventInfoBox
                signal={signal}
                companyName={companyName}
                signalsDescription={signalsDescription}
                data-automation="signal-event-info-ad-network"
            />
        );
    }

    if (type === SignalType.Traffic) {
        return <TrafficSignalEventInfoBox signal={signal} />;
    }

    if (type === SignalType.Ecommerce) {
        return (
            <EcommerceSignalEventInfoBox
                signal={signal}
                data-automation="signal-event-info-ecommerce"
            />
        );
    }

    return null;
};

export default SignalEventInfoBox;
